import React from "react";
import Box from "@material-ui/core/Box";
import Accordion from "@material-ui/core/Accordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import "./../../feedback.scss";
import "./../../SectionsV1/Preview/preview.scss";
import TextEditor from "../../Components/TextEditor";

import { AccordionSummary, AccordionDetails } from './../../Components/Accordion'

import { CommentConstants } from "../../Constants/FeedbackConstants";

const TheoryQuestions = ({ theoryQuestionsData, showFeedbackComments, renderAddCommentSection, renderViewUnresolvedCommentSection }) => {

  const setCodeTextValue = (value) => {
  }

  const [expanded, setExpanded] = React.useState(true);
  const [readMore, setReadMore] = React.useState({});

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded);
  };
  return (
    <Accordion className="mtb-20" id="add-comment-parent" expanded={expanded} onChange={handleChange('panel1')}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box display="flex" style={{ width: "100%", alignItems: "center" }}>
          <div className="preview-subheader-title"> Theory Questions</div>

          <div className="preview-subheader-subtitle mrl-20">
            {" "}
            Time Spent: {theoryQuestionsData?.timeSpent} Mins
          </div>
        </Box>
        {showFeedbackComments && renderViewUnresolvedCommentSection(CommentConstants.THEORY_QUESTIONS)}
        {showFeedbackComments && renderAddCommentSection(CommentConstants.THEORY_QUESTIONS)}
      </AccordionSummary>

      <AccordionDetails>
        <Box display="flex" flexDirection="column" style={{ width: "100%" }}>
          {theoryQuestionsData?.questions?.map((data, index) => {
            return (
              <Box
                display="flex"
                flexDirection="column"
                style={{ width: "100%" }}
                key={`theory-preview-${index + 1}`}
              >
                <Box display={"flex"} width="97%" gap="10px">
                <Box whiteSpace='nowrap'>{index+1}.&nbsp;</Box> 
                <div className={( !readMore[index]) ? `theory-question-question-statement theory-questions-unformatted rich-text-statement ${data?.questionLink ? 'underline' : ''}`:
                  `theory-questions-unformatted rich-text-statement ${data?.questionLink ? 'underline' : ''}`}
                  dangerouslySetInnerHTML={{ __html: data?.questionAsked }} onClick={(e) => openQuestionLink(data?.questionLink)}></div>                
                  {data?.questionAsked?.length >= 380 ? readMore[index]?<Box onClick={(e)=>{setReadMore({ ...readMore, [index]:false})}} className="read-more">Read less</Box>:
                    <Box onClick={()=>setReadMore({ ...readMore, [index]: true})} className="read-more">Read more</Box> : ''}
                </Box>

                {data?.codeText &&

                  <TextEditor
                    theoryPreview
                    readOnly
                    value={data?.codeText || ""}
                    setValue={setCodeTextValue}
                  />
                }

                <div className="theory-answers" dangerouslySetInnerHTML={{ __html: data?.candidateResponse }}>
                  {/* {data?.candidateResponse} */}
                </div>

                {index + 1 !== theoryQuestionsData?.questions?.length && (
                  <div
                    style={{
                      width: "100%",
                      border: "1px solid #CDCDCD",
                      margin: "20px",
                    }}
                  ></div>
                )}
              </Box>
            );
          })}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default TheoryQuestions;